/* eslint no-empty-pattern: "off" */
/* eslint no-empty-function: "off" */
/* eslint class-methods-use-this: "off" */

class BaseLogicCallbacks {
  async shouldGoToStep({}) {
    return {
      moveToNextStep: true,
    };
  }

  async onStepChanged({}) {
  }

  onInitForm({}) {
  }

  async finishForm() {
    return {
      finishedForm: true,
    };
  }
}

export default BaseLogicCallbacks;
